// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3xgQe","col":"styles_col__3I3CD","actions":"styles_actions__Vo11E","conflict":"styles_conflict__1RYdi"};